import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const SearchAirport = loadable(() => import('./SearchAirport'));

SearchAirport.getInitialState = getInitialState;

export default SearchAirport;
